module.exports = __webpack_public_path__ + "media/images/icons/home-879745bf0a53e53e362e14f2d0ebdd68.svg";